<script setup lang="ts">
import type { Folder } from '@/types';

defineProps<{ folder: Folder }>();
</script>

<template>
	<div
		class="p-3 mb-2 border border-neutral-200 rounded-lg cursor-pointer hover:border-primary-300 hover:bg-primary-50 transition-colors"
	>
		<div class="flex items-center justify-between">
			<span class="text-sm font-medium text-neutral-800 truncate">{{ folder.name }}</span>
			<span class="text-xs text-neutral-500 whitespace-nowrap ml-2"
				>{{ folder.documents }} pièce{{ folder.documents > 1 ? 's' : '' }}</span
			>
		</div>
		<span class="text-xs text-neutral-500 mt-1">{{ folder.type }}</span>
	</div>
</template>
